import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProgressState {
  total: number;
  completed: number;
}

const initialState: ProgressState = {
  total: 0,
  completed: 0,
};

const progressSlice = createSlice({
  name: "progress",
  initialState,
  reducers: {
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
      state.completed = 0; // reset completed on new start
    },
    incrementCompleted: (state) => {
      state.completed += 1;
    },
    resetProgress: (state) => {
      state.total = 0;
      state.completed = 0;
    },
  },
});

export const { setTotal, incrementCompleted, resetProgress } = progressSlice.actions;
export default progressSlice.reducer;
